import { FaCheckDouble } from "react-icons/fa6";

import { Button } from "@/components/ui/button/button";
import { useEmpCheckinsModal } from "./use-checkin-modal";
import { EmployeeCheckinsModal } from "./checkin-modal";
import { useParams } from "react-router-dom";
import Cookies from "js-cookie";
import { useQuery } from "@tanstack/react-query";
import { getEmployeeCheckinsQueryOptions } from "@/config/queries/query-options";
import { useMemo } from "react";
import { format, isSameDay } from "date-fns";

export const EmployeeCheckinsComponent = () => {
  const { onOpenChange } = useEmpCheckinsModal();

  const { empId } = useParams() as {
    empId: string;
  };

  const key = Cookies.get("key") as string;

  const { data, isPending } = useQuery(
    getEmployeeCheckinsQueryOptions(key, empId)
  );

  const checkinsData = useMemo(() => {
    if (isPending) {
      return [];
    }

    if (data === undefined || data?.checkins === undefined) {
      return [];
    }

    const result = data?.checkins?.map((checkin) => {
      return {
        id: checkin?._id,
        mode: checkin?.mode === "IN" ? "Check in" : "Check out",
        time: format(new Date(checkin?.createdAt as Date), "PPpp"),
        createdAtIST: checkin?.createdAtIST,
        workDoneToday: checkin?.workDoneToday,
        attachments: checkin?.attachments,
      };
    });

    return result?.sort(
      (a, b) =>
        new Date(b?.createdAtIST).getTime() -
        new Date(a?.createdAtIST).getTime()
    );
  }, [isPending, data]);

  const todayCheckin = useMemo(() => {
    if (isPending) {
      return null;
    }

    if (data === undefined || data?.checkins === undefined) {
      return null;
    }

    const foundToday = data?.checkins?.find((item) => {
      const todayDate = new Date();
      const givenDate = new Date(item?.createdAt);

      const areEqual = isSameDay(todayDate, givenDate);

      return areEqual && item?.mode === "IN";
    });

    if (!foundToday) return null;

    return foundToday;
  }, [isPending, data]);

  return (
    <div className="w-60 min-h-24 rounded-md bg-card flex flex-col justify-between gap-1 shadow-sm border p-3">
      <div className="flex flex-row items-center pb-2 justify-between">
        <h2 className="text-sm font-medium">Employee Checkins</h2>

        <FaCheckDouble className="w-3 h-3" />
      </div>

      <div className="mb-2">
        {todayCheckin ? (
          <div className="text-xs">
            Employee Check in today - {format(todayCheckin?.createdAt, "p")}
          </div>
        ) : (
          <div className="text-xs">Employee not checked in today</div>
        )}
      </div>
      <div className="">
        <Button
          variant="default"
          size="sm"
          onClick={() => {
            onOpenChange(true);
          }}
        >
          View
        </Button>
      </div>

      <EmployeeCheckinsModal data={checkinsData} />
    </div>
  );
};
